type Args = {
  blockId: string;
};

export function getCmsTileGridTileQueryParamName({ blockId }: Args) {
  return `tile-${blockId}`;
}
